<app-generic-form [title]="displayTitle" [wide]="true">
  <form [formGroup]="activeForm" (ngSubmit)="onSubmit()" id="tableForm" form-content>
    @if (!lockTableType) {
      <div class="mb-4">
        <label class="form-label fw-bold">Tipo Tavolo:</label>
        <div class="d-flex gap-3">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tableTypeRadio"
              id="typeGDT"
              [checked]="activeTableType === 'GDT'"
              (change)="setTableType('GDT')">
            <label class="form-check-label" for="typeGDT">
              Tavolo GDT (Gioco da Tavolo)
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="tableTypeRadio"
              id="typeGDR"
              [checked]="activeTableType === 'GDR'"
              (change)="setTableType('GDR')">
            <label class="form-check-label" for="typeGDR">
              Tavolo GDR (Gioco di Ruolo)
            </label>
          </div>
        </div>
      </div>
    }

    @if (activeTableType === 'GDR') {
      <div class="mb-3">
        <label class="form-label" for="gameMasterName">Master / Game Master:</label>
        <input type="text" id="gameMasterName" class="form-control" formControlName="gameMasterName"
               [class.is-invalid]="activeForm.get('gameMasterName')?.invalid && activeForm.get('gameMasterName')?.touched">
        @if (activeForm.get('gameMasterName')?.invalid && activeForm.get('gameMasterName')?.touched) {
          <div class="invalid-feedback d-block">Il nome del Master è obbligatorio per i tavoli GDR.</div>
        }
      </div>
    }

    <div>
      <label class="form-label" for="tableName">
        Nome Tavolo @if (activeTableType === 'GDT') {<span class="text-muted fw-normal">(Opzionale)</span>}:
      </label>
      <input type="text" id="tableName" class="form-control" formControlName="tableName">
    </div>

    @if (activeTableType === 'GDR') {
      <div class="mt-4 mb-4">
        <label class="form-label" for="description">Descrizione Tavolo:</label>
        <quill-editor
          id="description"
          class="description-editor"
          [class.is-invalid]="activeForm.get('description')?.invalid && activeForm.get('description')?.touched"
          formControlName="description"
          [modules]="quillModules"
          format="html"
          placeholder="Scrivi la descrizione del tavolo...">
        </quill-editor>
        @if (activeForm.get('description')?.invalid && activeForm.get('description')?.touched) {
          <div class="invalid-feedback d-block">Inserisci una descrizione valida.</div>
        }
      </div>

      <div class="row">
        <div class="col-md-4 mb-3">
          <label class="form-label" for="minPlayers">Min Giocatori:</label>
          <input type="number" id="minPlayers" class="form-control" formControlName="minPlayers">
        </div>
        <div class="col-md-4 mb-3">
          <label class="form-label" for="maxPlayers">Max Giocatori:</label>
          <input type="number" id="maxPlayers" class="form-control" formControlName="maxPlayers">
        </div>
        <div class="col-md-4 mb-3">
          <label class="form-label" for="minAge">Età minima:</label>
          <input type="number" id="minAge" class="form-control" formControlName="minAge" min="0">
        </div>
      </div>
    } @else {
      <div class="row mt-3">
        <div class="col-md-6 mb-3">
          <label class="form-label" for="maxPlayers">Max Tavoli:</label>
          <input type="number" id="maxPlayers" class="form-control" formControlName="maxPlayers">
        </div>
      </div>
    }

    @if (activeTableType === 'GDT') {
      <app-generic-search-select
        label="Giochi (Multi-selezione)"
        placeholder="Cerca e aggiungi giochi..."
        [control]="boardgameSearchControl"
        [options]="availableGames()"
        [minSearchLength]="0"
        [displayFn]="displayGame"
        (itemSelected)="addBoardgame($event)">
      </app-generic-search-select>

      @if (selectedBoardgames().length > 0) {
        <div class="mt-2 d-flex flex-wrap gap-2">
          @for (game of selectedBoardgames(); track game.id) {
            <span class="badge bg-secondary d-flex align-items-center gap-1 p-2">
              {{ displayGame(game) }}
              <button type="button" class="btn-close btn-close-white" style="font-size: 0.5rem;" aria-label="Rimuovi" (click)="removeBoardgame(game)"></button>
            </span>
          }
        </div>
      }
    } @else {
      <app-generic-search-select
        label="Gioco"
        placeholder="Cerca un gioco..."
        [control]="playedGameControl"
        [options]="availableGames()"
        [minSearchLength]="0"
        [displayFn]="displayGame"
        (itemSelected)="gameSelected($event)">
      </app-generic-search-select>
    }

    <div class="d-flex justify-content-end mt-1 mb-2">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1"
        (click)="openCreateGameModal(createGameModal)">
        <i class="bi bi-plus-lg" aria-hidden="true"></i>Gioco
      </button>
    </div>

    <div class="mt-3">
      <label class="form-label" for="organizationId">Organizzazione</label>
      <select id="organizationId" class="form-select" formControlName="organizationId" required>
        <option [ngValue]="null" disabled>Seleziona un'organizzazione</option>
        @for (organization of filteredOrganizations; track organization.id) {
          <option [ngValue]="organization.id">{{ organization.organizationName }}</option>
        }
      </select>
    </div>

    @if (!preselectedEvent) {
      <div class="mt-3">
        <app-generic-search-select
          label="Evento associato (opzionale)"
          placeholder="Seleziona un evento"
          [control]="associatedEventControl"
          [options]="availableEvents"
          [minSearchLength]="0"
          [displayFn]="displayEvent">
        </app-generic-search-select>
      </div>
    }

    @if (activeTableType === 'GDR') {
      <div class="row mt-4">
        <div class="form-check d-flex justify-content-center col-4">
          <input class="form-check-input" type="checkbox" id="isOnline" formControlName="isOnline">
          <label class="form-check-label fw-bold" for="isOnline">
            Tavolo Online
          </label>
        </div>

        <div class="form-check d-flex justify-content-center col-4">
          <input class="form-check-input" type="checkbox" id="active" formControlName="active">
          <label class="form-check-label fw-bold" for="active">
            Attivo
          </label>
        </div>

        <div class="form-check d-flex justify-content-center col-4">
          <input class="form-check-input" type="checkbox" id="autoAccept" formControlName="autoAccept">
          <label class="form-check-label fw-bold" for="autoAccept">
            Accettazione Automatica
          </label>
        </div>
      </div>

      @if (!activeForm.get('isOnline')?.value) {
        <app-location-form [parentForm]="gdrForm" [required]="!activeForm.get('isOnline')?.value"></app-location-form>
      }
    }
  </form>
  <div form-actions>
    <button type="submit" form="tableForm" class="btn btn-primary w-100" [disabled]="activeForm.invalid">
      <i class="bi bi-check-lg me-1" aria-hidden="true"></i>{{submitLabel}}
    </button>
    <button type="button" class="btn btn-danger w-100 mt-2" (click)="onCancel()">
      <i class="bi bi-arrow-left me-1" aria-hidden="true"></i>Indietro
    </button>
  </div>
</app-generic-form>

<ng-template #createGameModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Crea nuovo gioco</h5>
    <button type="button" class="btn-close" aria-label="Chiudi" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <app-game-create
      [title]="''"
      [showCancel]="true"
      (cancel)="modal.dismiss()"
      (gameAdded)="onGameCreated($event, modal)">
    </app-game-create>
  </div>
</ng-template>
